<template>
   <div id="app">
      <div class="bg-pilke-dark text-white py-6">
         <div class="container mx-auto">
            <a href="https://pilkepaivakodit.fi">
               <img class="mx-auto block object-contain" width="80" src="./assets/pilke_logo_2x.png" />
            </a>
         </div>
      </div>

      <div class="font-sans antialiased container mx-auto max-w-md py-3 px-3" id="app">

         <div v-if="storeState.sent">
            <h1 class="text-3xl font-bold">Kiitos palautteestasi.</h1>
         </div>

         <div v-if="!storeState.sent">
            <div class="mb-5">
               <h2 class="text-2xl"> Valitse palautteen tyyppi </h2>
               <button v-bind:class="{'is-active': storeState.form === 'feedback'}" class="btn" @click="store.setForm('feedback')">Asiakaspalaute</button>
               <button v-bind:class="{'is-active': storeState.form === 'reminder'}" class="btn" @click="store.setForm('reminder')">Muistutusmenettely</button>
            </div>

            <feedback :store="store" v-if="storeState.form === 'feedback'"></feedback>
            <reminder :store="store" v-if="storeState.form === 'reminder'"></reminder>
         </div>
      </div>
   </div>
</template>

<script>
import feedback from '@/views/feedback'
import reminder from '@/views/reminder'
import store from '@/store'

export default {
   name: 'app',

   data () {
      return {
         sent: false,
         storeState: store.state,
         store: store
      }
   },

   components: {
      feedback,
      reminder
   },

   methods: {
   },

   computed: {
   }
}
</script>

<style>
</style>
